'use client'

import { useMenuMachine } from '~/utils/hooks'

import styles from './LanguageSwitcher.module.css'
import { LanguageSwitcherButton, LanguageSwitcherList, useLanguageSwitcher } from './LanguageSwitcher.utils'

export function LanguageSwitcher({ theme = styles }: { theme?: typeof styles }) {
  const mergedTheme = { ...styles, ...theme }

  const { options, currentLocation, onLanguageChange } = useLanguageSwitcher()

  const api = useMenuMachine({ closeOnSelect: true, positioning: { placement: 'top-end' } })
  const positionerProps = api.getPositionerProps()

  return (
    <>
      <LanguageSwitcherButton getTriggerProps={api.getTriggerProps} location={currentLocation} open={api.open} theme={theme} />

      <div {...positionerProps} style={{ ...positionerProps.style, zIndex: 1000 }} className={mergedTheme.languageSwitcherListContainer}>
        <LanguageSwitcherList options={options} onClick={onLanguageChange} getContentProps={api.getContentProps} theme={theme} />
      </div>
    </>
  )
}
